<script setup lang="ts">
import type { DialogRootEmits, DialogRootProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import { DialogRoot, useForwardPropsEmits } from 'reka-ui';

defineOptions({
    compatConfig: { MODE: 3 },
});

const props = defineProps<DialogRootProps & { overlayClass?: HTMLAttributes['class'] }>();
const emits = defineEmits<DialogRootEmits>();

const delegatedProps = reactiveOmit(props, 'overlayClass');

const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
    <DialogRoot
        v-slot="slotProps"
        data-slot="dialog"
        v-bind="forwarded"
    >
        <slot v-bind="slotProps"></slot>
    </DialogRoot>
</template>
